import { ServiceMaker, methods, services } from "../services";
// Leads APIs
export const getLeads = (id) =>
    ServiceMaker(`/crm/leads?tenant=${id}`, methods.GET, services.master);

export const createLead = (payload) =>
    ServiceMaker(`/crm/leads`, methods.POST, services.master, payload);

export const convertLead = (payload) =>
    ServiceMaker(
        `/crm/leads/${payload.LeadId}/convert?tenant=${payload.tenant}`,
        methods.POST,
        services.master,
        payload,
    );

export const editLead = (payload) =>
    ServiceMaker(
        `/crm/leads/${payload.id}`,
        methods.PUT,
        services.master,
        payload,
    );

export const viewLeads = (id) =>
    ServiceMaker(`/crm/leads/${id}`, methods.GET, services.master);

export const addNotes = (payload) =>
    ServiceMaker(
        `/crm/leads/add-notes/${payload.id}`,
        methods.POST,
        services.master,
        payload,
    );

export const sendEmail = (payload) =>
    ServiceMaker(
        `/crm/leads/send-email/${payload.id}`,
        methods.POST,
        services.master,
        payload,
    );
export const deleteLead = (payload) =>
    ServiceMaker(
        `/crm/leads/${payload.id}?tenant=${payload.tenant}`,
        methods.DELETE,
        services.master,
        payload.data || {},
    );